import React, { useState, useRef } from "react";
import { TextInput, Text, Box } from "grommet";
import styled from "styled-components";
import { formatNumeric, currencyToSymbol } from "../utils/currency";
import {useSession} from "next-auth/react";

const StyledTextInput = styled(TextInput)`
    text-align: right;
    &:focus {
        outline: none;
        box-shadow: none;
    }
`;

const CurrencyInput = ({ value = 0, onChange, useMinorCurrency = true, inputCurrency, prefix, ...rest }) => {
    const {data: session} = useSession();
    const { company: { currency: sessionCurrency } = {} } = session || {};
    const currency = inputCurrency || sessionCurrency || 'USD';

    const defaultValue = Number(useMinorCurrency ? value / 100 : value);
    const [inputValue, setInputValue] = useState(
        defaultValue === 0 ? undefined : formatNumeric(defaultValue, currency)
    );
    const inputRef = useRef(null);

    const handleChange = (event) => {
        event.preventDefault();

        // Get current cursor position
        const cursorPosition = event.target.selectionStart;

        // Remove non-numeric characters except decimal point
        const numericValue = event.target.value.replace(/[^0-9.]/g, "");
        setInputValue(numericValue);

        // Update the raw value for onChange
        event.target.value = useMinorCurrency
            ? Math.round(parseFloat(numericValue) * 100)
            : numericValue;
        onChange(event);

        // Restore cursor position after updating value
        setTimeout(() => {
            if (inputRef.current) {
                inputRef.current.selectionStart = cursorPosition;
                inputRef.current.selectionEnd = cursorPosition;
            }
        }, 0);
    };

    const handleBlur = (event) => {
        const formattedCurrency = formatNumeric(
            event.target.value.replace(/[^0-9.]/g, ""),
            currency
        );
        setInputValue(formattedCurrency);

        const formattedCurrencyWithoutCommas = formattedCurrency.replace(/,/g, "");
        event.target.value = useMinorCurrency
            ? Math.round(parseFloat(formattedCurrencyWithoutCommas) * 100)
            : formattedCurrencyWithoutCommas;
        onChange(event);
    };

    return (
        <Box direction="row" align="stretch">
            <Box justify="center" pad={{horizontal: prefix ? 'xxsmall' : 'small'}}>
                {prefix || <Text size="small" color="text-weak">{currencyToSymbol(currency)}</Text>}
            </Box>
            <Box flex>
                <StyledTextInput
                    ref={inputRef}
                    plain
                    value={inputValue}
                    placeholder={(0).toFixed(2)}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    {...rest}
                />
            </Box>
        </Box>
    );
};

export default CurrencyInput;
